<script>
  import { cn } from '@lib/utils'
  import Tooltip from '@components/tooltip.svelte'
  import TriggerChevron from '@components/trigger-chevron.svelte'
  let { open = $bindable(false), text, disabled = false, class: className = "button flex items-center gap-2", Icon, iconSize = 12, iconClass = "text-gray-500", hint, ...buttonProps } = $props()
</script>

<Tooltip {hint}>
  <button type="button" class={className} {disabled} {...buttonProps}>
    {#if Icon}
      <Icon size={iconSize} class={iconClass} />
    {/if}
    {text}
    <TriggerChevron {open} class={iconClass} />
  </button>
</Tooltip>